var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "imask", "./modules/valueObjects/cpf", "./modules/services/toastNotification", "./modules/components/selfServiceModal", "./modules/services/requests/selfServiceRequest", "./modules/services/geolocation", "../css/autoatendimento.module.scss"], function (require, exports, imask_1, cpf_1, toastNotification_1, selfServiceModal_1, selfServiceRequest_1, geolocation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    imask_1 = __importDefault(imask_1);
    cpf_1 = __importDefault(cpf_1);
    selfServiceModal_1 = __importDefault(selfServiceModal_1);
    selfServiceRequest_1 = __importDefault(selfServiceRequest_1);
    geolocation_1 = __importDefault(geolocation_1);
    var TxtCpf = document.getElementById('txt-cpf');
    var TxtDataNasc = document.getElementById('txt-data');
    var TxtRouteId = document.getElementById('txt-routeid');
    var BtnAceitar = document.getElementById('btn-aceitar');
    var BtnRecusar = document.getElementById('btn-recusar');
    var LnkTermTemplate = document.getElementById('lnk-term-template');
    var DivTermTemplate = document.getElementById('selfservice-template-modal');
    var DivMainContent = document.getElementById('self-service-main');
    var LnkTermTemplateClose = document.getElementById('selfservice-template-modal-close');
    var modal = null;
    var geoLocation = null;
    var toastMs = {
        validation: 5000,
        success: 10000,
        error: 10000
    };
    var selfServiceRequest = new selfServiceRequest_1.default(toastMs.success, toastMs.error);
    var MaskedTxtCpf = !TxtCpf ? null : imask_1.default(TxtCpf, {
        mask: 'XXX.XXX.XXX-XX',
        definitions: {
            'X': /[0-9]/
        },
        lazy: true
    });
    var MaskedTxtDataNasc = !TxtDataNasc ? null : imask_1.default(TxtDataNasc, {
        mask: Date,
        pattern: 'd/`m/`Y',
        blocks: {
            d: {
                mask: imask_1.default.MaskedRange,
                from: 1,
                to: 31,
                maxLength: 2,
            },
            m: {
                mask: imask_1.default.MaskedRange,
                from: 1,
                to: 12,
                maxLength: 2,
            },
            Y: {
                mask: imask_1.default.MaskedRange,
                from: 1900,
                to: new Date().getFullYear(),
                maxLength: 4,
            }
        },
        format: function (date) {
            var day = date.getDate().toString();
            var month = (date.getMonth() + 1).toString();
            var year = date.getFullYear().toString();
            if (Number(day) < 10)
                day = "0" + day;
            if (Number(month) < 10)
                month = "0" + month;
            return [day, month, year].join('/');
        },
        parse: function (str) {
            var dayMonthYear = str.split('/');
            return new Date(Number(dayMonthYear[2]), Number(dayMonthYear[1]) - 1, Number(dayMonthYear[0]));
        },
        lazy: true,
        min: new Date(1900, 0, 1),
        max: (function () {
            var now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), now.getDate());
        })()
    });
    var OnLoad = function () { return __awaiter(void 0, void 0, void 0, function () {
        var routeId, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    AddEvents();
                    routeId = GetRouteId();
                    if (!routeId)
                        return [2];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, geolocation_1.default()];
                case 2:
                    geoLocation = _a.sent();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3, 4];
                case 4:
                    modal = new selfServiceModal_1.default(routeId, selfServiceRequest, geoLocation, Reset);
                    return [2];
            }
        });
    }); };
    var AddEvents = function () {
        EnableDisableFormSubmit();
        TxtCpf === null || TxtCpf === void 0 ? void 0 : TxtCpf.addEventListener('input', function (e) { return OnCpfInput(e); });
        TxtDataNasc === null || TxtDataNasc === void 0 ? void 0 : TxtDataNasc.addEventListener('input', function (e) { return OnDataNascInput(e); });
        TxtCpf === null || TxtCpf === void 0 ? void 0 : TxtCpf.addEventListener('focusout', function (e) { return OnCpfFocusOut(e); });
        TxtDataNasc === null || TxtDataNasc === void 0 ? void 0 : TxtDataNasc.addEventListener('focusout', function (e) { return OnDataNascFocusOut(e); });
        BtnAceitar === null || BtnAceitar === void 0 ? void 0 : BtnAceitar.addEventListener('click', function (e) { return AnswerTermModal(e, true); });
        BtnRecusar === null || BtnRecusar === void 0 ? void 0 : BtnRecusar.addEventListener('click', function (e) { return AnswerTermModal(e, false); });
        LnkTermTemplate === null || LnkTermTemplate === void 0 ? void 0 : LnkTermTemplate.addEventListener('click', function (e) { return ToggleTermModal(e); });
        LnkTermTemplateClose === null || LnkTermTemplateClose === void 0 ? void 0 : LnkTermTemplateClose.addEventListener('click', function (e) { return TermModalClose(e); });
        document.addEventListener('keydown', function (e) { return OnEscKeyDown(e); });
    };
    var _answerTermModalFired = false;
    var AnswerTermModal = function (e, answer) { return __awaiter(void 0, void 0, void 0, function () {
        var failedToOpen, routeId_1, routeId, cpf, dataNasc, payload, guid, _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    failedToOpen = true;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, , 6, 7]);
                    e.preventDefault();
                    if (_answerTermModalFired)
                        return [2];
                    _answerTermModalFired = true;
                    SetAriaHiddenAll(true);
                    DisableControls(true);
                    if (!modal) {
                        routeId_1 = GetRouteId();
                        if (routeId_1 == null)
                            return [2];
                        modal = new selfServiceModal_1.default(routeId_1, selfServiceRequest, geoLocation);
                    }
                    if (!TxtCpf || !TxtDataNasc)
                        return [2];
                    EnableDisableFormSubmit();
                    routeId = GetRouteId();
                    cpf = GetCpf();
                    dataNasc = GetDataNasc();
                    payload = {
                        RouteId: routeId,
                        CPF: cpf.value,
                        BirthDate: dataNasc
                    };
                    if (!IsCpfValid(cpf, true, true) || !IsDataNascValid(dataNasc, true, true))
                        return [2];
                    if (routeId === null) {
                        console.error('RouteId inválido');
                        return [2];
                    }
                    return [4, SearchCpfAndGenerateProtocol(payload)];
                case 2:
                    guid = _e.sent();
                    if (!guid || !cpf.value || !dataNasc)
                        return [2];
                    _b = (_a = modal).Open;
                    _c = [answer, guid, cpf.value, dataNasc];
                    if (!answer) return [3, 4];
                    return [4, GetActivities(routeId)];
                case 3:
                    _d = _e.sent();
                    return [3, 5];
                case 4:
                    _d = null;
                    _e.label = 5;
                case 5:
                    _b.apply(_a, _c.concat([_d]));
                    failedToOpen = false;
                    return [3, 7];
                case 6:
                    _answerTermModalFired = false;
                    if (failedToOpen) {
                        SetAriaHiddenAll(false);
                        DisableControls(false);
                    }
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    var SearchCpfAndGenerateProtocol = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, selfServiceRequest.SearchCpfAndGenerateProtocol(payload)];
                case 1:
                    response = _b.sent();
                    if ((_a = response.obj) === null || _a === void 0 ? void 0 : _a.success) {
                        return [2, Promise.resolve(response.obj.protocol)];
                    }
                    else {
                        if (response.message)
                            toastNotification_1.ToastNotification.Error(response.message, toastMs.error);
                        return [2, Promise.resolve(null)];
                    }
                    return [3, 3];
                case 2:
                    error_1 = _b.sent();
                    toastNotification_1.ToastNotification.Error(error_1.message, toastMs.error);
                    return [2, Promise.resolve(null)];
                case 3: return [2];
            }
        });
    }); };
    var GetActivities = function (routeId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, selfServiceRequest.GetActivities(routeId)];
                case 1: return [2, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.obj];
                case 2:
                    error_2 = _b.sent();
                    toastNotification_1.ToastNotification.Error(error_2.message, toastMs.error);
                    return [2, Promise.resolve(null)];
                case 3: return [2];
            }
        });
    }); };
    var ChangeBtnAceitarEnabledState = function () {
        var disabled = ['cursor-not-allowed', 'bg-opacity-25'];
        var enabled = ['cursor-pointer', 'hover:bg-green-600', 'bg-opacity-100'];
        ChangeButtonEnabledState(BtnAceitar, enabled, disabled);
    };
    var ChangeBtnRecusarEnabledState = function () {
        var disabled = ['cursor-not-allowed', 'bg-opacity-25'];
        var enabled = ['cursor-pointer', 'hover:bg-gray-700', 'bg-opacity-100'];
        ChangeButtonEnabledState(BtnRecusar, enabled, disabled);
    };
    var ChangeButtonEnabledState = function (btn, bgValidClasses, bgInvalidClasses) {
        var _a, _b, _c, _d;
        if (!btn)
            return;
        var valid = IsFormValid();
        if (valid) {
            (_a = btn.classList).remove.apply(_a, bgInvalidClasses);
            (_b = btn.classList).add.apply(_b, bgValidClasses);
            btn.disabled = false;
        }
        else {
            (_c = btn.classList).remove.apply(_c, bgValidClasses);
            (_d = btn.classList).add.apply(_d, bgInvalidClasses);
            btn.disabled = true;
        }
    };
    var DisableControls = function (disable) {
        if (LnkTermTemplate)
            LnkTermTemplate.disabled = disable;
        if (TxtCpf)
            TxtCpf.disabled = disable;
        if (TxtDataNasc)
            TxtDataNasc.disabled = disable;
        if (BtnAceitar)
            BtnAceitar.disabled = disable;
        if (BtnRecusar)
            BtnRecusar.disabled = disable;
    };
    var EnableDisableFormSubmit = function () {
        ChangeBtnAceitarEnabledState();
        ChangeBtnRecusarEnabledState();
    };
    var GetRouteId = function () {
        var val = null;
        if (!TxtRouteId)
            return val;
        val = !isNaN(+TxtRouteId.value) ? Number(TxtRouteId.value) : null;
        return val;
    };
    var GetCpf = function () {
        var _a;
        return new cpf_1.default((_a = TxtCpf === null || TxtCpf === void 0 ? void 0 : TxtCpf.value) !== null && _a !== void 0 ? _a : null);
    };
    var GetDataNasc = function () {
        var _a;
        var val = (_a = MaskedTxtDataNasc === null || MaskedTxtDataNasc === void 0 ? void 0 : MaskedTxtDataNasc.typedValue) !== null && _a !== void 0 ? _a : null;
        return val;
    };
    var IsCpfValid = function (cpf, printMsg, focus) {
        if (cpf === void 0) { cpf = null; }
        if (printMsg === void 0) { printMsg = false; }
        if (focus === void 0) { focus = false; }
        if (!cpf)
            cpf = GetCpf();
        var valid = cpf.IsValid();
        if (!valid && printMsg) {
            toastNotification_1.ToastNotification.Alert('É necessário preencher corretamente o CPF', toastMs.validation);
            if (focus)
                TxtCpf === null || TxtCpf === void 0 ? void 0 : TxtCpf.focus();
        }
        return valid;
    };
    var IsDataNascValid = function (dataNasc, printMsg, focus) {
        if (printMsg === void 0) { printMsg = false; }
        if (focus === void 0) { focus = false; }
        if (!dataNasc)
            dataNasc = GetDataNasc();
        var valid = !!dataNasc;
        if (!valid && printMsg) {
            toastNotification_1.ToastNotification.Alert('É necessário preencher corretamente a data de nascimento', toastMs.validation);
            if (focus)
                TxtDataNasc === null || TxtDataNasc === void 0 ? void 0 : TxtDataNasc.focus();
        }
        return valid;
    };
    var IsFormValid = function () {
        return IsCpfValid(null, false) && IsDataNascValid(null, false);
    };
    var OnCpfInput = function (e) {
        var valid = IsCpfValid(null, false, false);
        EnableDisableFormSubmit();
        if (valid) {
            SetInvalid(e.target, false);
            TxtDataNasc === null || TxtDataNasc === void 0 ? void 0 : TxtDataNasc.focus();
        }
    };
    var OnCpfFocusOut = function (e) {
        var valid = IsCpfValid(null, true, false);
        var elem = e.target;
        SetInvalid(elem, !valid);
        EnableDisableFormSubmit();
    };
    var OnDataNascInput = function (e) {
        var valid = IsDataNascValid(null, false, false);
        EnableDisableFormSubmit();
        if (valid)
            SetInvalid(e.target, false);
    };
    var OnDataNascFocusOut = function (e) {
        var valid = IsDataNascValid(null, true, false);
        SetInvalid(e.target, !valid);
        EnableDisableFormSubmit();
    };
    var OnEscKeyDown = function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            TermModalClose();
        }
    };
    var Reset = function () {
        if (MaskedTxtCpf)
            MaskedTxtCpf.value = '';
        if (MaskedTxtDataNasc)
            MaskedTxtDataNasc.value = '';
        EnableDisableFormSubmit();
        SetAriaHiddenAll(false);
        DisableControls(false);
    };
    var SetAriaHiddenAll = function (val) {
        if (!DivMainContent || !DivMainContent.children)
            return;
        DivMainContent.setAttribute('aria-hidden', val ? 'true' : 'false');
    };
    var SetInvalid = function (elem, invalid) {
        var _a, _b, _c, _d;
        var invalidBorder = ['border-2', 'border-red-600'];
        var validBorder = ['border-2', 'border-white'];
        if (!elem)
            return;
        if (invalid) {
            (_a = elem.classList).remove.apply(_a, validBorder);
            (_b = elem.classList).add.apply(_b, invalidBorder);
        }
        else {
            (_c = elem.classList).remove.apply(_c, invalidBorder);
            (_d = elem.classList).add.apply(_d, validBorder);
        }
    };
    var _toggleTermModal = false;
    var ToggleTermModal = function (e) {
        if (e === void 0) { e = null; }
        var failedToOpen = true;
        try {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            if (_toggleTermModal)
                return;
            _toggleTermModal = true;
            SetAriaHiddenAll(true);
            DisableControls(true);
            DivTermTemplate === null || DivTermTemplate === void 0 ? void 0 : DivTermTemplate.classList.remove('hidden');
            failedToOpen = false;
        }
        finally {
            _toggleTermModal = false;
            if (failedToOpen) {
                SetAriaHiddenAll(false);
                DisableControls(false);
            }
        }
    };
    var TermModalClose = function (e) {
        if (e === void 0) { e = null; }
        if (e)
            e.preventDefault();
        if (!DivTermTemplate || DivTermTemplate.classList.contains('hidden'))
            return;
        DivTermTemplate.classList.add('hidden');
        SetAriaHiddenAll(false);
        DisableControls(false);
    };
    window.addEventListener('load', OnLoad);
});
